window['PetRescue'] = window['PetRescue'] || {}
const PetRescue = window['PetRescue']

PetRescue.Public = {}
PetRescue.Admin = {}
PetRescue.Shared = {}
